import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
//i18n
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

//Import images
// import avatar3 from "../../../assets/images/users/avatar-3.jpg"
// import avatar4 from "../../../assets/images/users/avatar-4.jpg"
// import notificationSound from "../../../assets/sounds/iphone_circle.mp3"
import ticketQueryAction from "store/cmFpc2VUaWNrZXQ/actions"
import { isEmpty } from "lodash"
import "./styles.scss"
import { Notifications } from "react-push-notification"
import moment from "moment"
import api from "helpers/Api"

const NotificationDropdown = (props) => {
  const dispatch = useDispatch()
  // console.log(props, "props")
  //Reducer state
  const { user = {} } = useSelector((state) => state.session)

  const empId = localStorage.getItem("empId")
  const userId = !isEmpty(user) ? user.id : empId

  const { ticket_notifications = [] } = useSelector(
    (state) => state.raiseTicket
  )
  //api call
  const [notificationsCall, setNotificationsCall] = useState(false)
  // initial state
  const [state, setState] = useState({
    menu: "",
  })
  useEffect(() => {
    // let interval
    if (props.ticketNotification == true) {
      setNotificationsCall(true)
      setTimeout(() => {
        setNotificationsCall(false)
      }, 2000)
    }
  }, [])

  console.log(state.menu, "menu")
  // const [notificationsDataSet, setNotificationsDataSet] = useState(false)
  const [notifyCount, setNotifyCount] = useState("")

  const toggle = () => {
    setState((prevState) => ({
      menu: !prevState.menu,
    }))
  }

  // const sound = new Audio(notificationSound)
  const colorOptions = [
    {
      background: "#e83e8c",
      colorKey: 1,
      color: "white",
    },
    {
      background: "#3788d8",
      colorKey: 2,
      color: "white",
    },
    {
      background: "#34c38f",
      colorKey: 3,
      color: "white",
    },
    {
      background: "#e9660edb",
      colorKey: 4,
      color: "white",
    },
    {
      background: "#bb86fc",
      colorKey: 5,
      color: "white",
    },
    {
      background: "#34c38f",
      colorKey: 6,
      color: "white",
    },
    {
      background: "#3788d8",
      colorKey: 7,
      color: "white",
    },
    {
      background: "#e83e8c",
      colorKey: 8,
      color: "white",
    },
    {
      background: "#bb86fc",
      colorKey: 9,
      color: "white",
    },
    {
      background: "#e9660edb",
      colorKey: 10,
      color: "white",
    },
  ]

  const notificationsTable =
    ticket_notifications && ticket_notifications.length > 0
      ? ticket_notifications.map((data, index) => {
          const notifications =
            !isEmpty(data) && data && data.toEmpIds.length > 0
              ? data.toEmpIds.find((employee) => employee.empId == userId)
              : ""

          return {
            colorKey: index + 1,
            createdAt: data.createdAt,
            description: data.description,
            fromEmpId: data.fromEmpId,
            fromEmpName: data.fromEmpName,
            profileUrl: data.profileUrl,
            queryId: data.queryId,
            ticketData: data,
            requestedBy: data.requestedBy,
            status: data.status,
            title: data.title,
            toEmpId: data.toEmpId,
            toEmpName:
              data.toEmpId && !isEmpty(notifications)
                ? notifications.employeeName
                : "",
            updatedAt: data.updatedAt,
            updatedBy: data.updatedBy,
            __v: data.__v,
            _id: data._id,
          }
        })
      : []

  useEffect(() => {
    if (props.ticketNotification == true && notificationsCall == true) {
      const notificationCount =
        props.notifications_data && props.notifications_data.length > 0
          ? props.notifications_data.length
          : 0

      console.log("new notifications sent")
      // sound.play()
      dispatch(
        ticketQueryAction.loadTicketNotifications({
          userId: userId,
        })
      )
      setNotifyCount(notificationCount)
    } else {
      const notificationCount =
        notificationsTable.length > 0 ? notificationsTable.length : 0
      setNotifyCount(notificationCount)
    }
  }, [props, ticket_notifications])

  useEffect(() => {
    if (state.menu == true) {
      dispatch(
        ticketQueryAction.loadTicketNotifications({
          userId: userId,
        })
      )
    }
  }, [state])
  console.log(notificationsCall, "notificationsCall")

  return (
    <React.Fragment>
      <Notifications />
      <Dropdown
        isOpen={state.menu}
        toggle={toggle}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
          // onClick={() => {

          // }}
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">{notifyCount}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <a href="#" className="small">
                  {" "}
                  View All
                </a>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {notificationsTable && notificationsTable.length > 0 ? (
              notificationsTable.map((data) => {
                // console.log(data, "notification data")
                const empName =
                  !isEmpty(data) && data.fromEmpName
                    ? data.fromEmpName.slice(0, 1)
                    : "--"
                const createdDate = !isEmpty(data.createdAt)
                  ? moment(data.createdAt).format(`hh:mm A`)
                  : "--"
                const colorCode =
                  colorOptions.length > 0
                    ? colorOptions.find(
                        (color) => color.colorKey == data.colorKey
                      )
                    : ""
                // console.log(colorCode, "colorCode")
                return (
                  <Link
                    key={data._id}
                    to={{
                      pathname: "/ticket-inprogress-received",
                      state: {
                        row: data.ticketData,
                        ticketId: data.queryId,
                        mode: "Notifications",
                      },
                    }}
                    className="text-reset notification-item"
                  >
                    <div
                      className="d-flex"
                      style={{
                        marginTop: "-4px",
                      }}
                      onClick={() => {
                        const usersToNotify = { notifyId: data._id }
                        api
                          .post(
                            "/mark_as_read_ticket_notification",
                            usersToNotify
                          )
                          .then(
                            (response) =>
                              // const data = response.json()
                              // console.log("Notifications sent:", data.message)
                              response.data && response.data.data
                            // sound.play()
                          )
                          .catch((error) => Promise.reject(error))
                        dispatch(
                          ticketQueryAction.loadTicketNotifications({
                            userId: userId,
                          })
                        )
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: colorCode
                            ? colorCode.background
                            : "#f38303",
                          color: colorCode ? colorCode.color : "black",
                          borderRadius: "50%",
                          height: "36px",
                          padding: "6px 0px",
                          textAlign: "center",
                          minWidth: "36px",
                        }}
                        className="me-3"
                      >
                        <span
                          className="font-size-14"
                          style={{ fontWeight: 650 }}
                        >
                          {/* <i className="bx bx-cart" /> */}
                          {empName}
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mt-0 mb-1">{data.fromEmpName}</h6>
                        <div className="font-size-12 text-muted">
                          <div
                            className="description-html-tag"
                            style={{
                              width: "300px",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: !isEmpty(data.description)
                                ? data.description.replace(
                                    /<img /g,
                                    `<img style="width: 280px; height: 150px "`
                                  )
                                : "",
                            }}
                          ></div>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {data.createdAt ? createdDate : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                )
              })
            ) : (
              <div
                className="mt-3"
                style={{
                  textAlign: "center",
                }}
              >
                {"No Notifications found"}
              </div>
            )}

            {/* <Link to="" className="text-reset notification-item">
              <div className="d-flex">
                <img
                  src={avatar3}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">James Lemire</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t("It will seem like simplified English") + "."}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />
                      {props.t("1 hours ago")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Link> */}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
  ticketsData: PropTypes.any,
  toggleClick: PropTypes.any,
  ticketNotification: PropTypes.any,
  notifications_data: PropTypes.any,
}

export default withTranslation()(NotificationDropdown)
